import { SvgIcon, SvgIconProps } from '@mui/material';

const BarChartIcon = (props: SvgIconProps): JSX.Element => {
  return (
    <SvgIcon {...props} viewBox="0 0 40 40" fill="none">
      <mask
        id="mask0_2005_3558"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="40"
        height="40"
      >
        <rect width="40" height="40" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2005_3558)">
        <path
          d="M27.222 33.3334V21.6667H33.3333V33.3334H27.222ZM16.9445 33.3334V6.66669H23.0554V33.3334H16.9445ZM6.66663 33.3334V15H12.7779V33.3334H6.66663Z"
          fill="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default BarChartIcon;
